import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { Observable } from "rxjs";

import { EventTypes } from "src/app/core/constants/event-types";
import { DialogService } from "src/app/core/services/dialog.service";
import { BaseFormPageComponent } from "../../../shared/base/components/base-form-page.component";
import { CreatePhonebookCommand } from "./../../../../core/api/models/create-phonebook-command";
import { UpdatePhonebookCommand } from "./../../../../core/api/models/update-phonebook-command";
import { PhonebooksService } from "./../../../../core/api/services/phonebooks.service";
import { FormPageConfig } from "./../../../../core/models/form-page-config.model";
import { GetPhonebooksWithPaginationDto } from "./../../../../core/models/phonebook-tree.model";
import { CommonModule } from "@angular/common";
import { BaseFormModule } from "src/app/shared/components/base/base-component/base-form.module";
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";

@Component({
    selector: "app-phonebook-form",
    templateUrl: "./phonebook-form.component.html",
    styleUrls: ["./phonebook-form.component.scss"],
    imports: [BaseFormModule, MatDialogModule, ModalTitleComponent]
})
export class PhonebookFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  title: string;
  model: CreatePhonebookCommand = {};
  formPageConfig: FormPageConfig<GetPhonebooksWithPaginationDto> = {};
  modelWithPagination$: Observable<any>;
  items$: Observable<Array<GetPhonebooksWithPaginationDto>>;

  input_parentId: number;

  //#endregion

  constructor(
    protected currentService: PhonebooksService,

    private dialogService: DialogService,
    private dialogRef: MatDialogRef<PhonebookFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    this.formPageConfig.editData = data?.editData;
    this.input_parentId = data?.parentId;
  }

  ngOnInit() {
    try {
      this.getVocabs();
      this.initForm();
      this.title = this.formPageConfig.title;

      //edit mode
      if (this.formPageConfig.editData && this.formPageConfig.isEditMode)
        this.model = Object.assign({}, this.formPageConfig.editData);

      if (this.input_parentId) this.model.parentId = this.input_parentId;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl(this.model?.name, Validators.required),
      parentId: new FormControl(this.model?.parentId),
      //deviceConnectionPort: new FormControl(this.model?.deviceId, [Validators.maxLength(16)]),
      isPublic: new FormControl(this.model?.isPublic),
      isShowNumber: new FormControl(this.model?.isShowNumber),
      customFields: new FormControl(),
      //isSendMessageAfterAddFromDevice: new FormControl(),
      //dynamicTemplateId: new FormControl(),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreatePhonebookCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .phonebooksCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdatePhonebookCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .phonebooksUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region final methods

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.unSubs();
    this.dialogRef.close(true);
  }

  //#endregion
}
